import React from "react";
import { Modal, Carousel } from "react-bootstrap";
import SafeImage from "../subComponents/SafeImage";

const ZoomModal = ({ show, onClose, images = [], initialIndex = 0 }) => {
  const [carouselIndex, setCarouselIndex] = React.useState(initialIndex);

  React.useEffect(() => {
    setCarouselIndex(initialIndex);
  }, [initialIndex]);

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Gift Images</Modal.Title>
      </Modal.Header>
      <Modal.Body className="zoom-carousel">
        {Array.isArray(images) && images.length > 0 ? (
          <Carousel
            activeIndex={carouselIndex}
            onSelect={(i) => setCarouselIndex(i)}
          >
            {images.map((imgUrl) => (
              <Carousel.Item key={imgUrl}>
                <SafeImage
                  src={imgUrl}
                  alt={`Gift Image`}
                  style={{
                    width: "100%",
                    maxHeight: "500px",
                    objectFit: "contain",
                  }}
                  className="d-block mx-auto"
                />
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <div className="text-center">
            <SafeImage
              src={null}
              alt="No Gift Image"
              style={{
                width: "200px",
                height: "200px",
                objectFit: "contain",
              }}
              className="d-block mx-auto"
            />
            <p className="mt-3 text-muted">No gift images available</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ZoomModal;
